import {
    SetupDataStore,
    PrequalificationResponseStore,
    getSoftPrequalContinuationId,
} from '@servicetitan/financing-workflow-shared';
import { useEffect } from 'react';

export const TransitionToHardApp = ({ onCompleted }: { onCompleted: () => void }) => {
    const { setupData, setSetupData } = SetupDataStore.useStore();
    const { prequalificationResponse } = PrequalificationResponseStore.useStore();

    useEffect(() => {
        const continuationId = getSoftPrequalContinuationId(prequalificationResponse);
        if (!continuationId || !setupData) {
            return;
        }

        if (
            prequalificationResponse &&
            'prequalId' in prequalificationResponse &&
            prequalificationResponse.prequalId
        ) {
            setSetupData({
                ...setupData,
                prequalificationId: prequalificationResponse.prequalId,
            });
        } else if (
            prequalificationResponse &&
            'loanId' in prequalificationResponse &&
            prequalificationResponse.loanId
        ) {
            setSetupData({
                ...setupData,
                loanId: prequalificationResponse.loanId,
            });
        }
        onCompleted();
    }, [prequalificationResponse, onCompleted, setupData, setSetupData]);

    return null;
};
